import * as classNames from 'classnames';
import * as React from 'react';
import { IValidatorPackage } from '../../Validators';

import './CheckboxGroup.css';

interface ICheckboxGroupProps {
    label: string;
    required?: boolean;
    selectedValue: string[];
    handleChange: (value: string) => void;
    optionValues: string[];
    optionLabels: string[];
    deferErrors: boolean;
    validators: IValidatorPackage[];
}

interface ICheckboxGroupState {
    touched: boolean;
}

class CheckboxGroup extends React.PureComponent<ICheckboxGroupProps, ICheckboxGroupState> {
    constructor(props: ICheckboxGroupProps) {
        super(props);

        this.state = {
            touched: false
        };
    }

    onClickOption = (value: string) => {
        this.props.handleChange(value);
    }

    handleKeyDown = (value: string, e: any) => {
        if (e.key === ' ' || e.key === 'Enter') {
            this.props.handleChange(value);
        }
    }

    render() {
        let valid = true;
        let errorMsg = '';
        this.props.validators.forEach((validatorPackage) => {
            if (!valid) {
                return;
            }
            if (validatorPackage.validator(this.props.selectedValue) === false) {
                valid = false;
                errorMsg = validatorPackage.errorMessage;
            }
        });
        const showError = !valid && (this.props.deferErrors === false);
        // console.log(showError);
        const CheckboxGroupClasses = classNames('CheckboxGroup', {
            'CheckboxGroup--error': showError
        });

        return (
            <div className={CheckboxGroupClasses}>
                <div className={'CheckboxGroup-label'}>
                    {this.props.label}
                    {this.props.required && (
                        <span className={'CheckboxGroup-required'}>{' *'}</span>
                    )}
                </div>
                {this.props.optionValues.map((value, index) => {
                    const boxClasses = classNames('CheckboxGroup-option-box', {
                        'CheckboxGroup-option-box--selected': this.props.selectedValue.includes(value)
                    });
                    return (
                        <div key={index} className={'CheckboxGroup-option'}>
                            <div 
                                className={boxClasses} 
                                tabIndex={0} 
                                onKeyDown={this.handleKeyDown.bind(this, value)} 
                                onClick={this.onClickOption.bind(this, value)}
                            >
                                <div className={'CheckboxGroup-option-box-inner'}>{}</div>
                            </div>
                            <div className={'CheckboxGroup-option-label'}>
                                {this.props.optionLabels[index]}
                            </div>
                        </div>
                    );
                })}
                {showError && (
                    <div className={'CheckboxGroup-error'}>{errorMsg}</div>
                )}
            </div>
        );
    }
}

export default CheckboxGroup;
